import React, { useMemo } from 'react'
import { EditCartItemProps, SipValidationType, SwpValidationType } from '../types'
import { Box, Grid, Skeleton, useTheme } from '@mui/material'
import { Formik, useFormik } from 'formik';
import { LumpsumScheme, SwpScheme } from './Scheme';
import dayjs from 'dayjs';
import { InvestmentFundType } from '../../../redux-store/types/api-types';
import { MpowerValidationType } from '../../investorOverview/types';
import { MandateCreation } from '../../../redux-store/types/investorProfile';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { CustomeBlueDatePicker, CustomeBlueDropDown, CustomeModalButton, CustomeNumberInput } from '../../investorOverview/transcation/FromInput';
import { SWP_FIRST_ORDER_FLAG_LABEL, WEEKLYDAYS } from '../../../utils/constant';
import MFCheckbox from '../../../lib/formik/Checkbox';

type Props = {
    data: EditCartItemProps
    currentTransactionType: string
    validation: SwpValidationType
    scheme: InvestmentFundType
    schemeLoading: boolean
    bankDetails: MandateCreation[]
}

export const handlePickDate = (ArrayOfDate: Array<string | number>, date: dayjs.Dayjs) => {

    if (ArrayOfDate.length === 0) {
        return false
    }
    if (typeof ArrayOfDate[0] === 'number') {
        return !ArrayOfDate?.includes(dayjs(date).date());
    }

    if (typeof ArrayOfDate[0] === 'string') {
        const capitalizedDays = ArrayOfDate.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );
        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
        return !day?.includes(dayjs(date).day());
    }
    return false
}

export default function Swp(props: Props) {
    const theme = useTheme()

    const { data, currentTransactionType, validation, scheme, schemeLoading, bankDetails } = props
    const { onSave, swpAmount, frequency, onCancel, noOfInstallments, swpDate, isLoading, bankAccountNumber, firstOrder } = data
    const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);

    const frequencyArray = scheme?.frequencies?.filter(item => item.frequency && item.transactionType === 'SWP')
    // sheme
    const schemeValidation = SwpScheme({ validation, swpAmount, frequency, noOfInstallments, swpDate, bankAccountNumber, scheme })


    // handleSubmit
    function handleSubmitBtn(formValues: any) {
        formValues.swpDate = dayjs(formValues.swpDate).format('DD/MM/YYYY')
        onSave(
            data.id,
            currentTransactionType,
            {
                amount: formValues.swpAmount,
                frequency: formValues.frequency,
                noOfInstallment: formValues.noOfInstallments,
                // sipDate: dayjs(formValues.swpDate).format('DD/MM/YYYY'),
                sipDate: formValues.swpDate,
                mandateId: formValues.mandates,
                firstOrderFlag: formValues.firstOrder ? "Y" : "N",
            }
        )
    }

    const Daily = scheme.validations?.filter((item) => item?.frequency === 'DAILY' && item?.transactionType === 'SWP')?.[0]
    const Weekly = scheme.validations?.filter((item) => item?.frequency === 'WEEKLY' && item?.transactionType === 'SWP')?.[0]
    const WeeklyDays = scheme.validations?.filter((item) => item?.frequency === 'WEEKLYDAYS' && item?.transactionType === 'SWP')?.[0]
    const Monthly = scheme.validations?.filter((item) => item?.frequency === 'MONTHLY' && item?.transactionType === 'SWP')?.[0]
    const Quarterly = scheme.validations?.filter((item) => item?.frequency === 'QUARTERLY' && item?.transactionType === 'SWP')?.[0]
    const Yearly = scheme.validations?.filter((item) => item?.frequency === 'YEARLY' && item?.transactionType === 'SWP')?.[0]

    const stpMinAmount = (key = 'minimumInstallmentAmount' as keyof MpowerValidationType, frequency: string) => {

        if (frequency === 'WEEKLY') {
            return Weekly?.[key]
        } else if (frequency === 'MONTHLY') {
            return Monthly?.[key]
        } else if (frequency === 'QUARTERLY') {
            return Quarterly?.[key]
        } else if (frequency === 'YEARLY') {
            return Yearly?.[key]
        } else if (frequency === 'DAILY') {
            return Daily?.[key]
        } else if (frequency === 'WEEKLYDAYS') {
            return WeeklyDays?.[key]
        } else {
            return 0
        }
    }



    return (
        <Formik
            enableReinitialize
            validationSchema={schemeValidation}
            initialValues={{
                swpAmount: swpAmount || '0',
                frequency: frequency || '',
                noOfInstallments: noOfInstallments || '0',
                swpDate: dayjs(swpDate, 'DD/MM/YYYY') || '',
                mandates: bankAccountNumber,
                firstOrder: firstOrder,
            }}
            onSubmit={handleSubmitBtn}>
            {(formik) => {
                return <Box component='form' onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeNumberInput
                                isLoading={schemeLoading}
                                disable={isLoading}
                                textType="number"
                                label='SWP Amount'
                                name={`swpAmount`}
                                minlabel={`Min: ${String.fromCharCode(parseInt(currencySymbol, 16))} ${stpMinAmount('minimumInstallmentAmount', formik.values.frequency)}`}
                                removeIcons={true}
                                warningText={'amount'}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeBlueDropDown
                                name={`frequency`}
                                isLoading={schemeLoading}
                                disabled={isLoading}
                                label='Frequency'
                                list={frequencyArray?.map(item => ({ value: item.frequency, label: item.frequency })) as any}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeNumberInput
                                isLoading={schemeLoading}
                                disable={isLoading}
                                textType="number"
                                label='No. of Installments'
                                name={`noOfInstallments`}
                                minlabel={`Min: ${stpMinAmount('minimumInstallments', formik.values.frequency)}`}
                                minValue={validation?.installment?.minValue}
                                removeIcons={true}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeBlueDatePicker
                                disablePast={true}
                                disabled={isLoading}
                                isLoading={schemeLoading}
                                label='SWP Date'
                                name={`swpDate`}
                                shouldDisableDate={(date: dayjs.Dayjs) => handlePickDate(stpMinAmount('investmentDates', formik.values.frequency) || [], date)}
                                minDate={dayjs().add(1, 'day')}
                            // disableDateList={stpMinAmount('investmentDates')}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12} sx={{ paddingBottom: "20px" }}>
                            <CustomeBlueDropDown
                                name={`mandates`}
                                disabled={isLoading}
                                isLoading={schemeLoading}
                                label='Mandate'
                                list={[...bankDetails]?.map((item: MandateCreation) => ({ value: item?.bankAccountNumber, label: `${item?.bankName}-${item?.bankAccountNumber}` }))}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} alignSelf="flex-end" sx={{ paddingBottom: "20px" }}>
                            {schemeLoading && (
                                <Skeleton
                                    variant="rectangular"
                                    width='100%'
                                    height={50}
                                    sx={{ borderRadius: 2 }}
                                />
                            )}
                            {!schemeLoading && (
                                <Box
                                    sx={{
                                        mt: 1,
                                        width: '100%',
                                        padding: '4px 0px 4px 15px',
                                        backgroundColor: theme.palette.primary[50],
                                        borderRadius: 2,
                                        color: theme.palette.primary[500]
                                    }}
                                >
                                    <MFCheckbox
                                        name="firstOrder"
                                        label={SWP_FIRST_ORDER_FLAG_LABEL}
                                        disabled
                                    />
                                </Box>
                            )}
                        </Grid>
                        <Grid
                            item
                            container
                            xs={12}
                            mt={2}
                            sx={{
                                justifyContent: "center",
                                alignItems: "center",
                                borderTop: `0.5px solid ${theme.palette.text.secondary}B2`
                            }}
                        >
                            <Grid
                                item
                                container
                                xs={10}
                                sx={{
                                    columnGap: "35px",
                                    flexWrap: "nowrap",
                                    paddingTop: "30px",
                                }}
                            >
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <CustomeModalButton
                                        // isLoading={isLoading || schemeLoading}
                                        disabled={isLoading || schemeLoading}
                                        onClick={() => onCancel()}
                                        type='button'
                                        variant='outlined'
                                        btnText='Cancel'
                                        boxStyle={{
                                            color: theme.palette.text.primary,
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={6}
                                >
                                    <CustomeModalButton
                                        disabled={!formik.dirty || schemeLoading}
                                        type='submit'
                                        isLoading={isLoading}
                                        btnText='Save Changes'
                                        variant='contained'
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Box>
            }}

        </Formik>
    )
}